
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Card, CardActions, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import FieldCollection from "components/fields/fieldCollection/FieldCollection"
import TextField from "components/fields/textField/TextField"
import { Link as NavLink, useNavigate } from 'react-router-dom';
import { UserService } from "services/UserService"
import Form from "components/forms/Form"
import { Bootstrapper } from "Bootstrapper"
import Link from "components/buttons/Link"
import LoadingButton from "components/buttons/LoadingButton"
import DOMPurify from "dompurify"
import { CommonUtil } from "utils/CommonUtil"

export enum PolicyType{
    Privacy,
    Eula,
    Tos,
    Security,
    Cve,
}

export interface PolicyViewerProps{
    type: PolicyType;
}

  const getPolicyTitle = (t: PolicyType) => {
    switch(t){
        case PolicyType.Eula:
            return 'License Agreement';
        case PolicyType.Privacy:
            return 'Privacy Policy';
        case PolicyType.Security:
            return 'Security Policy';
        case PolicyType.Tos:
            return 'Terms of Service';
        case PolicyType.Cve:
            return 'Vulnerability Management Policy';
        default:
            throw Error('Policy type not supported: ' + t);
    }
  }

  const getPolicyPathKey = (t: PolicyType) => {
    switch(t){
        case PolicyType.Eula:
            return 'eula';
        case PolicyType.Privacy:
            return 'privacy';
        case PolicyType.Security:
            return 'security';
        case PolicyType.Tos:
            return 'tos';
        case PolicyType.Cve:
            return 'vulnerability-management';
        default:
            throw Error('Policy type not supported: ' + t);
    }
  }


export const PolicyViewer = (props: PolicyViewerProps) => {
  const {type, ...rest} = props;
  const [html, setHtml] = useState('')
  


  useEffect(() => {
    setPolicyHtmlAsync(type);
}, [type])

const setPolicyHtmlAsync = async(type: PolicyType) => {
    const pathKey = getPolicyPathKey(type);
    const res = await fetch(`/policies/${pathKey}.html`);
    const raw = await res.text();
    const clean = DOMPurify.sanitize(raw, {
        USE_PROFILES: { html: true }
    });
    setHtml(clean);
}

return(
<Page>
<Section>
    <Container maxWidth="md">
            <div>                        
                <TitleBlock fullWidth sx={{justifyContent: 'left'}}>
                    <Title textAlign="left">{getPolicyTitle(type)}</Title>
                </TitleBlock>
                {CommonUtil.isNullOrEmpty(html) && <Text>Loading...</Text>}
                <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>

    </Container>
</Section>
</Page>
)

}


export default PolicyViewer